module.exports = __webpack_public_path__ + "img/crowdfunding00.95c53936.jpg";